/**
 *
 * stickybox
 *
 */
import helper from '../helper';

const _h = ( obj ) => {
    return helper.creatObject( obj );
}

const stickybox = () => {

    const headerHeight = helper.header.offsetHeight
    let lastHeight = 0
    let delay = 0
    let zIndex = 99998
    /**
     * get stikybox elements and clone it to new element
     * then pass it to pinBox() function 
     *
     * @return     {<type>}  The sticky box.
     */
    const getStickyBox = () => {
        const wpadminbar = document.getElementById('wpadminbar')
        let out = wpadminbar && wpadminbar.offsetHeight && window.innerWidth > 600 ? wpadminbar.offsetHeight : 0

        const fixedBox = document.querySelectorAll('.wp-block-hayyabuild-stickybox');
        if ( fixedBox ) {
            fixedBox.forEach( element => {
                const afterHeaderEnd = element.classList.contains('hayyabuild-stickybox--after-header-end')
                const onlyShowFixed = element.classList.contains('hayyabuild-stickybox--only-fixed')
                const addContainer = element.classList.contains('hayyabuild-stickybox--add-container')
                const height = element.offsetHeight
                const showPosition = out + lastHeight
                const showOnScrollUp = element.classList.contains('hayyabuild-stickybox--show-on-scrollup')

                const prop = {
                    id: element.id,
                    afterHeaderEnd: afterHeaderEnd,
                    onlyShowFixed: onlyShowFixed,
                    addContainer: addContainer,
                    showOnScrollUp: showOnScrollUp,
                    height: height,
                    showPosition: showPosition,
                    scrollPostion: afterHeaderEnd ? headerHeight : element.offsetTop,
                    hidePosition: (height * -1) + out - 20,
                    delay: delay,
                    elementLastHeight: lastHeight
                }

                let el = onlyShowFixed ? element : element.cloneNode(true)

                pinBox( el, prop)

                lastHeight += height;
                delay += 300
                zIndex += -10
            })
        }
    }

    /**
     * append and style cloned content box
     *
     * @param      {<type>}  el      { parameter_description }
     * @param      {<type>}  prop    The property
     * @return     {<type>}  { description_of_the_return_value }
     */
    const pinBox = ( element, prop ) => {
        const { id, hidePosition, scrollPostion, showPosition, afterHeaderEnd, onlyShowFixed, addContainer, showOnScrollUp } = prop

        const cssStyle = {
            display: 'none',
            top: hidePosition+'px',
            zIndex: zIndex
        }

        if ( window.pageYOffset > scrollPostion ) {
            cssStyle.top = showPosition + 'px'
            cssStyle.display = 'block'
        }

        afterHeaderEnd ?  delete cssStyle.display : delete cssStyle.top

        _h( element ).css( cssStyle ).addClass( 'stickybox-fixed' )//.setAttr( 'data-scrollpostion', scrollPostion )

        if ( ! onlyShowFixed ) {
            element.id = id + '-cloned'

            let children = element.querySelectorAll('[id]')

            children && children.forEach( child => {
                child.id = child.id + '-cloned'
            })
        } else {
            element.classList.remove('hayyabuild-stickybox--only-fixed')
        }

        if ( addContainer ) {
            let stickyboxContainer = element.querySelector('.stickybox-container')
            stickyboxContainer && stickyboxContainer.classList.add('container')
        }

        document.body.append(element)

        // let el = document.getElementById(element.id)
        // let style = window.getComputedStyle( el )
        // console.log('==> ', style.getPropertyValue('border-color'), el.classList)

        stickyboxFixed( element, prop )
    }




    /**
     * scroll event
     *
     * @param      {object}  prop    The property
     * @return     {null}  {}
     */
    const stickyboxFixed = ( element, prop ) => {
        const { id, hidePosition, scrollPostion, showPosition, afterHeaderEnd, onlyShowFixed, addContainer, showOnScrollUp, elementLastHeight } = prop

        let lastScroll = window.scrollY
        let cssStyle = {}
        let run = false

        let direction = 'down'
        let location = 'out'
        let tmpDirection = ''
        let tmpLocation = ''

        window.addEventListener('scroll', event => {
            let delay = afterHeaderEnd ? prop.delay : 0
            direction = window.scrollY > lastScroll ? 'up' : 'down'
            location = window.scrollY > scrollPostion ? 'in' : 'out';

            // When show at up and scrolling page to down
            // and arrived to original postion then run it again
            run = direction !== tmpDirection || location !== tmpLocation;

            if ( run ) {

                cssStyle = { display: 'none', top: hidePosition + 'px' }
                
                // if ( window.scrollY + elementLastHeight > scrollPostion && ! ( showOnScrollUp && direction === 'up' ) ) {
                if ( window.scrollY > scrollPostion && ! ( showOnScrollUp && direction === 'up' ) ) {
                // if ( window.scrollY > scrollPostion && ! ( ! showOnScrollUp && direction === 'up' ) ) {
                    cssStyle = { display: 'block', top: showPosition + 'px' }
                } else {
                    delay = 0
                }

                // delet CSS (display) from style
                // when after Header End is activated
                afterHeaderEnd && delete cssStyle.display;

                setTimeout( () => _h( element ).css( cssStyle ), delay )

                run = false;
            }

            // get latest scroll position
            lastScroll = window.scrollY;
            
            // inside or outside scroll position
            tmpLocation = location;

            // run it again when position changed
            tmpDirection = direction;
        });
        // lastHeight += prop.height;
    }

    /**
     * call getStickyBox function when window loaded
     */
    window.addEventListener( 'load', getStickyBox );
}

export default stickybox
